import React from 'react';
import { Loader, Box } from 'braid-design-system';

const PageLoader = () => (
  <Box
    padding={['large', 'xxlarge']}
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="full"
    data-testid="page-loader"
  >
    <Loader />
  </Box>
);

export default PageLoader;
